import React, { useState, useEffect } from "react";
import { Typography, Grid, Modal, Stack, Button } from "@mui/material";
import CategoryCard from "./CategoryCard";
import ACImage from "../../../assets/Images/ac_Image.png";
import CleaningImage from "../../../assets/Images/home_cleaning_Image.png";
import SalonImage from "../../../assets/Images/Salon_at_Home_Image.png";
import PlumbingImage from "../../../assets/Images/plumbling_Image.png";
import ElectricalImage from "../../../assets/Images/electrical_Image.png";
import AppliancesImage from "../../../assets/Images/appliances_Image.png";
import PackersImage from "../../../assets/Images/Packers_Movers_Image.png";
import PestImage from "../../../assets/Images/pest_control_Image.png";
import BeautyBlack from "../../../assets/Images/Categories/BeautyBlack.png";
import BeautyBlue from "../../../assets/Images/Categories/BeautyBlue.png";
import GardeningBlack from "../../../assets/Images/Categories/GardeningBlack.png";
import GardeningBlue from "../../../assets/Images/Categories/GardeningBlue.png";
import InteriorDecorBlack from "../../../assets/Images/Categories/InteriorDecorBlack.png";
import InteriorDecorBlue from "../../../assets/Images/Categories/InteriorDecorBlue.png";
import PlumbingBlack from "../../../assets/Images/Categories/PlumbingBlack.png";
import PlumbingBlue from "../../../assets/Images/Categories/PlumbingBlue.png";
import BuilderBlack from "../../../assets/Images/Categories/BuilderBlack.png";
import BuilderBlue from "../../../assets/Images/Categories/BuilderBlue.png";
import TutoringBlack from "../../../assets/Images/Categories/TutoringBlack.png";
import TutoringBlue from "../../../assets/Images/Categories/TutoringBlue.png";
import DogGroomingBlack from "../../../assets/Images/Categories/DogGroomingBlack.png";
import DogGroomingBlue from "../../../assets/Images/Categories/DogGroomingBlue.png";
import BakerBlack from "../../../assets/Images/Categories/BakerBlack.png";
import BakerBlue from "../../../assets/Images/Categories/BakerBlue.png";
import CarWashBlack from "../../../assets/Images/Categories/CarWashBlack.png";
import CarWashBlue from "../../../assets/Images/Categories/CarWashBlue.png";
import WeddingBlack from "../../../assets/Images/Categories/WeddingBlack.png";
import WeddingBlue from "../../../assets/Images/Categories/WeddingBlue.png";
import { Box } from "@mui/system";
import _ from "lodash";
import "../../../App.css";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const CategoriesCard = () => {
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const categoryClickHandler = (selectedobj) => {
    setSelectedCategory(selectedobj);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedCategory)) {
      setOpen(true);
    }
  }, [selectedCategory]);
  return (
    <div style={{ marginLeft: "5%" }}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack justifyContent="center" alignItems="center">
            <img
              src={selectedCategory.img}
              style={{ marginTop: "20px", marginBottom: "20px" }}
            />
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: "20px" }}
            >
              {selectedCategory.title}
            </Typography>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Link
                to="/create-request"
                state={{ requestParam: selectedCategory.title }}
              >
                <Button variant="contained" color="primary">
                  Post Request
                </Button>
              </Link>
              <Link to="/FindExperts" state={{ title: selectedCategory.title }}>
                <Button variant="outlined" color="primary">
                  Find Experts
                </Button>
              </Link>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Typography
        variant="h5"
        component="h1"
        style={
          isMobile
            ? {
                marginTop: "30px",
                fontWeight: "600",
                fontSize: "32px",
                lineHeight: "24px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                marginBottom: "30px",
              }
            : {
                marginTop: "30px",
                fontWeight: "600",
                fontSize: "32px",
                lineHeight: "24px",
                marginBottom: "30px",
              }
        }
      >
        Categories
      </Typography>
      <Grid container>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={BeautyBlack}
            cardActiveImage={BeautyBlue}
            cardTitle="Beauty"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={GardeningBlack}
            cardActiveImage={GardeningBlue}
            cardTitle="Gardening"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={InteriorDecorBlack}
            cardActiveImage={InteriorDecorBlue}
            cardTitle="Interior Decor"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PlumbingBlack}
            cardActiveImage={PlumbingBlue}
            cardTitle="Plumbing"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={BuilderBlack}
            cardActiveImage={BuilderBlue}
            cardTitle="Builder"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={TutoringBlack}
            cardActiveImage={TutoringBlue}
            cardTitle="Tutoring"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={DogGroomingBlack}
            cardActiveImage={DogGroomingBlue}
            cardTitle="Dog Grooming"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={BakerBlack}
            cardActiveImage={BakerBlue}
            cardTitle="Baker"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={CarWashBlack}
            cardActiveImage={CarWashBlue}
            cardTitle="Car Wash"
          />
        </Grid>
        <Grid
          xs="auto"
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginLeft: "50px",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={WeddingBlack}
            cardActiveImage={WeddingBlue}
            cardTitle="Wedding"
          />
        </Grid>
        {/* <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={CleaningImage}
            cardTitle="Cleaning Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={SalonImage}
            cardTitle="Salon and Self Care"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PlumbingImage}
            cardTitle="Plumbing Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={ElectricalImage}
            cardTitle="Electrician Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={AppliancesImage}
            cardTitle="Appliances Maintenance"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PackersImage}
            cardTitle="Packaging and Movers"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PestImage}
            cardTitle="Pest Control"
            categoryClick={categoryClickHandler}
          />
        </Grid> */}
      </Grid>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          className="primary-button"
          style={{
            textTransform: "capitalize",
            padding: "12px 24px",
            borderRadius: "6px",
            marginTop: "30px",
            marginBottom: "54px",
          }}
        >
          View All
        </Button>
      </div>
    </div>
  );
};

export default CategoriesCard;
